<div class="vertical-filters" [ngClass]="{ collapsed: !isFiltersMenuOpen }">
  <div class="vertical-filters-header">
    <img src="assets/images/common/filter.svg" (click)="onToggleClick()" alt="filter" />
    <div>Filters</div>
    <img
      src="assets/images/arrows/chevron.svg"
      class="vertical-filters-header-img"
      (click)="onToggleClick()"
      alt="toggle"
    />
  </div>
  <div class="vertical-filters-options">
    @if (isFiltersMenuOpen) {
      @if (isFiltersReady$ | async) {
        <div class="vertical-filters-options-container">
          <div *ngFor="let optionGroup of optionsInsideCategories$ | async; let i = index">
            @if (!optionGroup.displayName) {
              <div
                *ngFor="let option of optionGroup.options"
                class="vertical-filters-option"
                [ngClass]="{
                  'vertical-filters-option-selected': selectedIds.has(option.id) && !option.disabled,
                  'vertical-filters-option-disabled': option.disabled,
                }"
                (click)="onSelect(option.id)"
              >
                <mat-checkbox
                  color="primary"
                  [checked]="selectedIds.has(option.id)"
                  (click)="$event.stopPropagation()"
                  (change)="onSelect(option.id)"
                >
                </mat-checkbox>
                <div class="vertical-filters-option-text" appLongTextTooltip>
                  {{ option.displayName | beautifyDisplayString }}
                </div>
              </div>
            }
            @if (optionGroup.displayName && !optionGroup.isDynamic) {
              <app-accordion
                [inMultiSelect]="true"
                [expanded]="expandedCategories[optionGroup.displayName]"
                [accordionTitle]="optionGroup.displayName | beautifyDisplayString"
                (accordionExpansionEvent)="expandClicked(optionGroup.displayName, $event)"
                [isNewFeature]="optionGroup.isNew === true"
              >
                <div
                  *ngFor="let option of optionGroup.options"
                  class="vertical-filters-option"
                  [ngClass]="{
                    'vertical-filters-option-selected': selectedIds.has(option.id) && !option.disabled,
                    'vertical-filters-option-disabled': option.disabled,
                  }"
                  (click)="onSelect(option.id)"
                >
                  <mat-checkbox
                    color="primary"
                    [checked]="selectedIds.has(option.id)"
                    (click)="$event.stopPropagation()"
                    (change)="onSelect(option.id)"
                  >
                  </mat-checkbox>
                  @if (option.iconPath) {
                    <img [src]="option.iconPath" class="option-img" />
                  }
                  @if (!option.disabled) {
                    <div class="vertical-filters-option-text" appLongTextTooltip>
                      {{
                        option.withoutBeautifyDisplayName
                          ? option.displayName
                          : (option.displayName | beautifyDisplayString)
                      }}
                    </div>
                  }
                </div>
              </app-accordion>
            }
          </div>
          <div>
            <app-accordion [inMultiSelect]="true" accordionTitle="Environment name">
              <app-autocomplete-api
                [searchValuesCtrl]="searchEnvironmentNameValuesCtrl"
                [pageFilters]="pageFilters"
                [filteredValues]="filteredEnvironmentNameValues"
                [isLoading$]="isEnvironmentNameLoading$"
                [filterType]="environmentNameFilterEnum"
                (optionOnSelection)="environmentNameSubmitted($event)"
              >
              </app-autocomplete-api>
            </app-accordion>
            <app-accordion [inMultiSelect]="true" [expanded]="false" accordionTitle="Created by">
              <app-autocomplete-api
                [searchValuesCtrl]="searchCreatedByValuesCtrl"
                [pageFilters]="pageFilters"
                [filteredValues]="filteredCreatedByValues"
                [isLoading$]="isCreatedByLoading$"
                [filterType]="createdByFilterEnum"
                (optionOnSelection)="createdBySubmitted($event)"
              >
              </app-autocomplete-api>
            </app-accordion>
            <app-accordion [inMultiSelect]="true" [expanded]="false" accordionTitle="Owned by">
              <app-autocomplete-api
                [searchValuesCtrl]="searchOwnedByValuesCtrl"
                [pageFilters]="pageFilters"
                [filteredValues]="filteredOwnedByValues"
                [isLoading$]="isOwnedByLoading$"
                [filterType]="ownedByFilterEnum"
                (optionOnSelection)="ownedBySubmitted($event)"
              >
              </app-autocomplete-api>
            </app-accordion>
            <app-accordion [inMultiSelect]="true" [expanded]="false" accordionTitle="Department">
              <app-autocomplete-api
                [searchValuesCtrl]="departmentFilter.valuesCtrl"
                [pageFilters]="pageFilters"
                [filteredValues]="departmentFilter.values"
                [isLoading$]="departmentFilter.isLoading$"
                [filterType]="departmentFilter.filterEnum"
                (optionOnSelection)="departmentSubmitted($event)"
              >
              </app-autocomplete-api>
            </app-accordion>
          </div>
        </div>
      } @else {
        <div class="filters-loading">
          <mat-spinner diameter="30"></mat-spinner>
        </div>
      }
    }
  </div>
</div>
<div [ngClass]="{ collapsed: isFiltersMenuOpen }">
  <img
    src="assets/images/arrows/filters-menu-closed.svg"
    (click)="onToggleClick()"
    class="collapsed-img"
    alt="collapse"
  />
</div>
